module.exports = __webpack_public_path__ + "static/media/thume.a9fc2342.jpg";